import { type TranslationKey, translationKey } from '@change-corgi/core/i18n';

import type { ShareAction } from 'src/app/shared/hooks/share';

import type { Channel } from './types';

type ChannelButtonConfig = {
	label: TranslationKey;
	successLabel?: TranslationKey;
	secondaryLabel?: TranslationKey;
	labelReplacements?: Record<string, string>;
};

const SHARE_BUTTON_CONFIG: Readonly<Record<Channel, ChannelButtonConfig>> = {
	facebook: { label: translationKey('fe.components.psf.share.buttons.short.facebook') },
	twitter: { label: translationKey('fe.components.psf.share.buttons.short.twitter') },
	whatsapp: { label: translationKey('fe.components.psf.share.buttons.short.whatsapp') },
	email: { label: translationKey('fe.components.psf.share.buttons.short.email') },
	sms: { label: translationKey('fe.components.psf.share.buttons.short.sms') },
	copy: {
		label: translationKey('fe.components.psf.share.buttons.copy_link'),
		successLabel: translationKey('fe.components.share_buttons.copied'),
	},
	mobileNativeShare: { label: translationKey('corgi.psf.share.buttons.short.mobile_share') },
	instagramStories: { label: translationKey('corgi.psf.share.buttons.short.instagram_stories') },
	instagram: { label: translationKey('fe.components.psf.share.buttons.short.instagram') },
	facebookMessenger: { label: translationKey('fe.components.psf.share.buttons.short.facebook_messenger') },
	line: { label: translationKey('fe.components.psf.share.buttons.short.line') },
	nextdoor: {
		label: translationKey('corgi.psf.share.buttons.short.nextdoor'),
	},
	reddit: {
		label: translationKey('corgi.petition_gamma.share.reddit'),
	},
	tiktok: {
		label: translationKey('corgi.psf.share.buttons.short.tiktok'),
	},
	vk: {
		label: translationKey('fe.components.petition_share.accordion.share_on_network'),
		labelReplacements: { socialNetwork: 'VK' },
	},
};

type Result = ReadonlyArray<{
	action: () => Promise<boolean>;
	channel: Channel;
	label: TranslationKey;
	url: string;
}>;

export function mapButtonConfigs(shareActions: ReadonlyArray<ShareAction<Channel>>): Result {
	return shareActions.map(({ action, channel, url }) => ({
		action,
		channel,
		url,
		...SHARE_BUTTON_CONFIG[channel],
	}));
}
